// src/api/authService.js
import axios from "axios";

async function requestWithTiming(label, request) {
  const startedAt = typeof performance !== "undefined" ? performance.now() : Date.now();
  try {
    const response = await request();
    const endedAt = typeof performance !== "undefined" ? performance.now() : Date.now();
    console.info(`[perf] API ${label} ${Math.round(endedAt - startedAt)}ms status=${response?.status ?? "unknown"}`);
    return response;
  } catch (error) {
    const endedAt = typeof performance !== "undefined" ? performance.now() : Date.now();
    console.warn(`[perf] API ${label} failed ${Math.round(endedAt - startedAt)}ms status=${error?.response?.status ?? "unknown"}`);
    throw error;
  }
}

export async function loginConsumer({ apiUrl, email, password, organization_id }) {
  const response = await requestWithTiming("consumer-login", () => axios.post(
    `${apiUrl}/api/consumers/login`,
    { email, password, organization_id },
    { withCredentials: true }
  ));
  return response.data;
}

export async function loginAdmin({ apiUrl, subscription_id, email, password }) {
  const payload = { subscription_id, email, password };
  const response = await requestWithTiming("organization-login", () => axios.post(
    `${apiUrl}/api/organizations/login`,
    JSON.stringify(payload),
    { headers: { "Content-Type": "application/json" }, withCredentials: true }
  ));
  return response.data;
}

export async function loginUser({ apiUrl, email, password }) {
  const payload = { name: email, password };
  const response = await requestWithTiming("user-login", () => axios.post(
    `${apiUrl}/authusers/token`,
    JSON.stringify(payload),
    { headers: { "Content-Type": "application/json" }, withCredentials: true }
  ));
  return response.data;
}

export async function fetchOrgProfile({
  apiUrl,
  subscription_id,
  email,
  token,
}) {
  const payload = { subscription_id, email };
  const response = await requestWithTiming("organization-profile", () => axios.post(
    `${apiUrl}/api/organizations/profile`,
    JSON.stringify(payload),
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  ));
  return response.data;
}

export async function visitOrganizationOnboarding({ apiUrl, organizationId, token }) {
  const response = await requestWithTiming("organization-onboarding-visit", () => axios.post(
    `${apiUrl}/api/organizations/${organizationId}/onboarding/visit`,
    {},
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      withCredentials: true,
    }
  ));
  return response.data;
}
